import {getLangKeyByValue} from '@services/helpers/langHandler'
import {postRequest} from '@services/api/axiosHandler'

import Operationmode from '@models/helpers/Operationmode'
import RoomtypesHasOperationmodesHasAirvolume from '@models/helpers/RoomtypesHasOperationmodesHasAirvolume'

import Building from '@models/building/Building'
import Installation from '../../models/airvolumes/Installation'
import Systemselection from '../../models/airvolumes/Systemselection'

import StoredRoomArticle from "../../models/articles/StoredRoomArticle";

export async function getSvg(units) {
  const building = Building.query().first()
  var svgUnits = []
  units.forEach((unit, unitIndex) => {
    if (unit.rooms.length == 0) return
    var storey = []
    var rooms = unit.rooms
    var basement = 0

    rooms.sort(function (a, b) {
      if (a.storey == b.storey) {
        // Price is only important when cities are the same
        return a.level > b.level ? 1 : -1
      }
      return a.storey > b.storey ? 1 : -1
    })
    var level = 0
    rooms.forEach((room) => {
      var deviceNumber = 0
      // if unit ventilation measure is not 3 or 4 then get room device number
      if (unit.ventilationMeasure != 3 && unit.ventilationMeasure != 4) {
        const devices = StoredRoomArticle.query().where('room_id', room.id).where('accessorygroup_id', 1).get()
        devices.forEach((device) => {
          deviceNumber += device.quantity
        })
      }

      var em = false
      if (unit.airvolume.ventilationMeasure != null && room.ventilationMeasure < 4) em = true
      var airvolume = room.airvolume.airvolume

      if (room.airvolume.operationmodeAirvolume > 1) {
        var operationmodeAirvolume = RoomtypesHasOperationmodesHasAirvolume.find(room.airvolume.operationmodeAirvolume)
        airvolume = operationmodeAirvolume.duration_airvolume + ' / ' + operationmodeAirvolume.need_airvolume

        //if duration_airvolume and need_airvolume are 0 then set airvolume to 0 / room.airvolume.airvolume
        if (operationmodeAirvolume.duration_airvolume == 0 && operationmodeAirvolume.need_airvolume == 0) {
          airvolume = 0 + ' / ' + room.airvolume.airvolume
        }
      }
      var operationmode = Operationmode.find(room.airvolume.operationmode)
      if (operationmode != null || operationmode != undefined) {
        operationmode = operationmode.label
      }
      var schemeRoom = {}
      var pipeAmmount = 0
      var pipesystem = 1
      room.valves.forEach((valve) => {
        pipeAmmount += parseInt(valve.pipesAmmount)
        pipesystem = valve.pipesystem
      })

      schemeRoom = {
        air_type: room.airType,
        ventilation_measure: room.ventilationMeasure,
        devices: deviceNumber,
        room_type: Lang(room.getRoomtype().label),
        air_volume: airvolume,
        //controlling_combo: controlling_combo,
        em: em,
        operationmode_id: room.operationmode,
        operationmode: operationmode,
        pipes_ammount: pipeAmmount,
        valves_ammount: room.valves.length,
        pipesystem: pipesystem,
        section: '',
        controlling_combo: room.controllingCombo,
      }

      var totalStorey = room.storey
      if (room.level != null) {
        totalStorey = totalStorey + room.level
        level = room.level
      } else {
        totalStorey = totalStorey + level
      }

      for (var i = 0; i <= totalStorey; i++) {
        if (typeof storey[i] === 'undefined') {
          var levelChar = ''
          var index = i
          if (i >= 2 && level > 0) {
            index = totalStorey - level
            if (index == 2 && i > 2) levelChar = i - 2 + ' '
            if (index > 2) index = index + i - totalStorey
          }

          storey[i] = {
            storey: levelChar + getLangKeyByValue('floors', index).text,
            rooms: [],
          }
        }
      }
      storey[totalStorey].rooms.push(schemeRoom)
      if (room.storey == 0) basement = 1
    })
    var storeyFiltered = storey.filter((e) => e.rooms.length > 0)

    // add device storey (installation.storey) and device level (systemselection.level) to svgUnits
    let device_storey = ''
    let device_level = ''
    const installation = Installation.query().where('unitId', unit.id).first()
    const systemselection = Systemselection.query().where('unitId', unit.id).first()
    if (systemselection && systemselection.deviceLevel) device_level = systemselection.deviceLevel + ' '
    if (installation && installation.storey) {
      device_storey = device_level + getLangKeyByValue('floors', installation.storey).text
    }

    // Find storey index matching storey in storeyFiltered by device_storey
    let storeyIndex = storeyFiltered.findIndex((e) => e.storey === device_storey)
    // If no storey found add device_storey to storeyFiltered
    if (storeyIndex === -1) {
      storeyFiltered.push({
        storey: device_storey,
        rooms: [],
      })
      storeyIndex = storeyFiltered.length - 1
    }
    // add device: true to storeyFiltered
    storeyFiltered[storeyIndex].device = true

    device_storey = Lang('lang.kwl.schema.device_installation') + ': ' + device_storey

    svgUnits[unitIndex] = {
      stories: storeyFiltered,
      ventilation_measure: unit.ventilationMeasure,
      building_type: building.type,
      basement: basement,
      device_storey: device_storey,
    }
  })
  return await postRequest('get/svg', {units: svgUnits})
}

export async function getControllingSvg(units) {
  const building = Building.query().first()
  var svgUnits = []
  var units = {}
  units.forEach(
    function (unit, unitIndex) {
      var ControllingCombo = {}
      var unitInCombo = 0
      unit.rooms.forEach(
        function (room, roomIndex) {
          if (room.ventilationMeasure != 5) return

          if (room.ventilationMeasure != 5 || room.controllingCombo == null) return
          if (!(room.controllingCombo in ControllingCombo)) {
            ControllingCombo[room.controllingCombo] = {
              controlling_combo: room.controllingCombo,
              em_rooms: [],
              snu_number: 0,
              kwl_rooms: [],
            }
          }
          room.devices.forEach(
            function (device) {
              if (device.quantity > 0 && (device.articles_id == 333 || device.articles_id == 727)) {
                ControllingCombo[room.controllingCombo].kwl_rooms.push(this.__(room.getRoomtype().label))
              }
            }.bind(this)
          )
          room.articles.forEach(
            function (device) {
              if (device.quantity > 0 && device.articles_id == 334) {
                ControllingCombo[room.controllingCombo].em_rooms.push(this.__(room.getRoomtype().label))
              }
              if (device.quantity > 0 && device.articles_id == 331) {
                ControllingCombo[room.controllingCombo].snu_number += 1
              }
            }.bind(this)
          )
        }.bind(this)
      )

      svgUnits[unitIndex] = ControllingCombo
    }.bind(this)
  )

  return axios.post('/get/svg/combo', {units: units}).then((response) => {
    var svgContent = response.data
    svgContent.forEach(
      function (svg, index) {
        this.units.forEach(function (unit, unitIndex) {
          if (unitIndex == index) unit.svg = svg
        })
        $('#combo_airdistribution_' + index).html(svg)
      }.bind(this)
    )
  })
}
